import { PRO_GRANT_AI_CREDITS } from 'src/components/buyCreditsDialog/benefits';

/**
 * The three Pro tiers, cheapest first -- mirrors the backend's PRO_TIER_ITEM_TYPES
 * and PREMIUM_PLAN_AI_GRANT. Every tier has the same plan (benefits.ts PRO_PLAN)
 * except for the AI-credit grant and the free monthly 1:1 call, which only Pro+
 * carries.
 */
export type ProTierType =
  | 'premium_profile_lite'
  | 'premium_profile_pro'
  | 'premium_profile_standard';

export const PRO_PLUS: ProTierType = 'premium_profile_standard';

export interface ProTier {
  type: ProTierType;
  name: string;
  aiCredits: number;
  monthlyCall: boolean;
}

export const PRO_TIERS: ProTier[] = [
  {
    type: 'premium_profile_lite',
    name: 'Pro Lite',
    aiCredits: 1000,
    monthlyCall: false,
  },
  {
    type: 'premium_profile_pro',
    name: 'Pro',
    aiCredits: PRO_GRANT_AI_CREDITS,
    monthlyCall: false,
  },
  {
    type: PRO_PLUS,
    name: 'Pro+',
    aiCredits: PRO_GRANT_AI_CREDITS,
    monthlyCall: true,
  },
];

export const PRO_TIER_TYPES: string[] = PRO_TIERS.map((tier) => tier.type);

/** Every item type a purchase of Pro comes as: the tiers, the legacy
 * unlimited pass and the app's free offer. */
const PRO_ITEM_TYPES = [
  ...PRO_TIER_TYPES,
  'premium_profile',
  'premium_profile_app_free',
];

export const isProItemType = (type?: string | null): boolean =>
  !!type && PRO_ITEM_TYPES.includes(type);

export const isProTierType = (type?: string | null): boolean =>
  !!type && PRO_TIER_TYPES.includes(type);

export const proTierOf = (type?: string | null): ProTier =>
  PRO_TIERS.find((tier) => tier.type === type) ??
  PRO_TIERS[PRO_TIERS.length - 1];
